import React, { useEffect, useState } from "react";
import { getPageBySlug } from "../lib/cms";
import { ShieldAlert } from "lucide-react";

export default function Persondata() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const page = await getPageBySlug("persondata");
        setPageData(page);
      } catch (err) {
        console.error("Error loading page data:", err);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  useEffect(() => {
    if (pageData) {
      document.title = pageData.title;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", pageData.meta_description || "");
      }
    }
  }, [pageData]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-light">
        <div className="animate-pulse text-brand-primary font-bold text-lg">Henter indhold...</div>
      </div>
    );
  }

  return (
    <div className="bg-brand-light min-h-screen py-12 lg:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider mb-4">
            Persondatapolitik
          </span>
          <h1 className="text-3xl sm:text-4xl font-black text-brand-dark tracking-tight mb-4">
            Sådan behandler vi dine persondata
          </h1>
          <p className="text-stone-600 text-sm sm:text-base max-w-2xl mx-auto leading-relaxed">
            Oplysningspligt for elever vedrørende behandling af personoplysninger i forbindelse med din køreuddannelse.
          </p>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-3xl border border-stone-200 shadow-xl overflow-hidden p-6 sm:p-10 lg:p-12 space-y-8">
          {/* Alert Box */}
          <div className="p-5 bg-stone-50 border border-stone-200 rounded-2xl flex items-start gap-3.5 text-stone-700">
            <ShieldAlert className="h-5.5 w-5.5 text-brand-primary shrink-0 mt-0.5" />
            <div>
              <strong className="font-bold block text-sm text-brand-dark">Dataansvarlig</strong>
              <span className="text-xs leading-relaxed">
                Carinas Køreskole, Gugvej 186 D, kld. tv., 9210 Aalborg SØ, CVR nr. 40126996 er dataansvarlig for behandlingen af dine personoplysninger.
              </span>
            </div>
          </div>

          {/* Verbatim Content Area */}
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: pageData.content }}
          />
        </div>
      </div>
    </div>
  );
}
